import {TQueryItem} from "../../constants";
import {IFilterDB, TFilter, TFilterOption} from "../search";

export interface ISearchDate {
  id: string,
  field: string;
  from: string | null;
  to: string | null;
}

export interface ISearchState {
  initialSearch: boolean;
  industry: string;
  db_set: string | null;
  query: TQueryItem[];
  dates: ISearchDate[];
  results_per_page: number;
  current_page: number;
  sort: string;
  filtersLoaded: boolean;
  selected_filters_ids: string[];
  applied_filters: TFilterOption[];
  available_filter_options: TFilterOption[];
  filters_db: IFilterDB;
  filter_display: TFilter | null;
  filters_key: string;
  suspendSearch: boolean;
  recent_query: boolean; // save in search history
}

export type ISearchEntry = {
  id: number;
  dateCreated: string;
  searchDateTime: string;
  count: number;
  url: string;
}

export type IPrevSearchState = {
  document:ISearchState;
  bibliography: ISearchState;
}

export const UpdateSearchAction: string = "update-search-action";
export const UpdatePrevSearchAction: string = "update-prev-search-action";
